import { render, staticRenderFns } from "./d-comment-entry.vue?vue&type=template&id=4b74a728&"
import script from "./d-comment-entry.vue?vue&type=script&lang=js&"
export * from "./d-comment-entry.vue?vue&type=script&lang=js&"
import style0 from "./d-comment-entry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports